import fr_coreg_iban_address_desktop from "./fr_coreg_iban_address_desktop";
import fr_coreg_iban_address_mobile from "./fr_coreg_iban_address_mobile";
import nl_coreg_iban_address_desktop from "./nl_coreg_iban_address_desktop";
import nl_coreg_iban_address_mobile from "./nl_coreg_iban_address_mobile";

import fr_new_branding_mobile from "./fr_new_branding_mobile";
import fr_new_branding_desktop from "./fr_new_branding_desktop";

import fr_new_branding_phone_optin_desktop from "./fr_new_branding_phone_optin_desktop";
import fr_new_branding_phone_optin_mobile from "./fr_new_branding_phone_optin_mobile";

import nl_new_branding_phone_optin_desktop from "./nl_new_branding_phone_optin_desktop";
import nl_new_branding_phone_optin_mobile from "./nl_new_branding_phone_optin_mobile";

import nl_new_branding_mobile from "./nl_new_branding_mobile";
import nl_new_branding_desktop from "./nl_new_branding_desktop";

import fr_tablet_nb_mobile from "./fr_tablet_nb_mobile";
import fr_tablet_nb_desktop from "./fr_tablet_nb_desktop";
import nl_tablet_nb_mobile from "./nl_tablet_nb_mobile";
import nl_tablet_nb_desktop from "./nl_tablet_nb_desktop";

import fr_template_slider_mobile from "./fr_template_slider_mobile";
import fr_template_slider_desktop from "./fr_template_slider_desktop";
import nl_template_slider_mobile from "./nl_template_slider_mobile";
import nl_template_slider_desktop from "./nl_template_slider_desktop";

import fr_template_carousel_mobile from "./fr_template_carousel_mobile";
import fr_template_carousel_desktop from "./fr_template_carousel_desktop";
import nl_template_carousel_mobile from "./nl_template_carousel_mobile";
import nl_template_carousel_desktop from "./nl_template_carousel_desktop";

import fr_carousel_phone_optin_mobile from "./fr_carousel_phone_optin_mobile";
import fr_carousel_phone_optin_desktop from "./fr_carousel_phone_optin_desktop";
import nl_carousel_phone_optin_mobile from "./nl_carousel_phone_optin_mobile";
import nl_carousel_phone_optin_desktop from "./nl_carousel_phone_optin_desktop";

import fr_template_si_2024_mobile from "./fr_template_si_2024_mobile";
import fr_template_si_2024_desktop from "./fr_template_si_2024_desktop";
import nl_template_si_2024_mobile from "./nl_template_si_2024_mobile";
import nl_template_si_2024_desktop from "./nl_template_si_2024_desktop";

import fr_optimisation_2024_a_mobile from "./fr_optimisation_2024_a_mobile";
import fr_optimisation_2024_a_desktop from "./fr_optimisation_2024_a_desktop";
import nl_optimisation_2024_a_mobile from "./nl_optimisation_2024_a_mobile";
import nl_optimisation_2024_a_desktop from "./nl_optimisation_2024_a_desktop";

import fr_optimisation_2024_b_mobile from "./fr_optimisation_2024_b_mobile";
import fr_optimisation_2024_b_desktop from "./fr_optimisation_2024_b_desktop";
import nl_optimisation_2024_b_mobile from "./nl_optimisation_2024_b_mobile";
import nl_optimisation_2024_b_desktop from "./nl_optimisation_2024_b_desktop";

import fr_default_2024_mobile from "./fr_default_2024_mobile";
import fr_default_2024_desktop from "./fr_default_2024_desktop";
import nl_default_2024_mobile from "./nl_default_2024_mobile";
import nl_default_2024_desktop from "./nl_default_2024_desktop";

import fr_default_2025_mobile from "./fr_default_2025_mobile";
import fr_default_2025_desktop from "./fr_default_2025_desktop";
import nl_default_2025_mobile from "./nl_default_2025_mobile";
import nl_default_2025_desktop from "./nl_default_2025_desktop";

import fr_carousel_2024_mobile from "./fr_carousel_2024_mobile";
import fr_carousel_2024_desktop from "./fr_carousel_2024_desktop";
import nl_carousel_2024_mobile from "./nl_carousel_2024_mobile";
import nl_carousel_2024_desktop from "./nl_carousel_2024_desktop";

import fr_carousel_2025_mobile from "./fr_carousel_2025_mobile";
import fr_carousel_2025_desktop from "./fr_carousel_2025_desktop";
import nl_carousel_2025_mobile from "./nl_carousel_2025_mobile";
import nl_carousel_2025_desktop from "./nl_carousel_2025_desktop";

import fr_iban_only_desktop from "./fr_iban_only_desktop";
import fr_iban_only_mobile from "./fr_iban_only_mobile";

import fr_carousel_cookbook_desktop from "./fr_carousel_cookbook_desktop";
import fr_carousel_cookbook_mobile from "./fr_carousel_cookbook_mobile";
import nl_carousel_cookbook_desktop from "./nl_carousel_cookbook_desktop";
import nl_carousel_cookbook_mobile from "./nl_carousel_cookbook_mobile";

import fr_cashback_desktop from "./fr_cashback_desktop";
import fr_cashback_mobile from "./fr_cashback_mobile";
import fr_2euros_2025_desktop from "./fr_2euros_2025_desktop";
import fr_2euros_2025_mobile from "./fr_2euros_2025_mobile";
import nl_2euros_2025_desktop from "./nl_2euros_2025_desktop";
import nl_2euros_2025_mobile from "./nl_2euros_2025_mobile";

import fr_2euros_2025_nobox_desktop from "./fr_2euros_2025_nobox_desktop";
import fr_2euros_2025_nobox_mobile from "./fr_2euros_2025_nobox_mobile";
import nl_2euros_2025_nobox_desktop from "./nl_2euros_2025_nobox_desktop";
import nl_2euros_2025_nobox_mobile from "./nl_2euros_2025_nobox_mobile";

import fr_2euros_2025_phone_last_desktop from "./fr_2euros_2025_phone_last_desktop";
import fr_2euros_2025_phone_last_mobile from "./fr_2euros_2025_phone_last_mobile";
import fr_2euros_2025_nobox_phone_last_desktop from "./fr_2euros_2025_nobox_phone_last_desktop";
import fr_2euros_2025_nobox_phone_last_mobile from "./fr_2euros_2025_nobox_phone_last_mobile";

import nl_2euros_2025_phone_last_desktop from "./nl_2euros_2025_phone_last_desktop";
import nl_2euros_2025_phone_last_mobile from "./nl_2euros_2025_phone_last_mobile";
import nl_2euros_2025_nobox_phone_last_desktop from "./nl_2euros_2025_nobox_phone_last_desktop";
import nl_2euros_2025_nobox_phone_last_mobile from "./nl_2euros_2025_nobox_phone_last_mobile";


import fr_cashback_fusion_avant_desktop from "./fr_cashback_fusion_avant_desktop";
import fr_cashback_fusion_avant_mobile from "./fr_cashback_fusion_avant_mobile";
import fr_cashback_fusion_apres_desktop from "./fr_cashback_fusion_apres_desktop";
import fr_cashback_fusion_apres_mobile from "./fr_cashback_fusion_apres_mobile";

import fr_giftchoice_desktop from "./fr_giftchoice_desktop";

import fr_giftchoice_white_desktop from "./fr_giftchoice_white_desktop";
import nl_giftchoice_white_desktop from "./nl_giftchoice_white_desktop";
import nl_giftchoice_desktop from "./nl_giftchoice_desktop";
import fr_default_2024_phone_last_desktop from "./fr_default_2024_phone_last_desktop";
import fr_default_2024_phone_last_mobile from "./fr_default_2024_phone_last_mobile";
import nl_giftchoice_mobile from "./nl_giftchoice_mobile";
import fr_giftchoice_mobile from "./fr_giftchoice_mobile";
import fr_giftchoice_white_mobile from "./fr_giftchoice_white_mobile";
import nl_giftchoice_white_mobile from "./nl_giftchoice_white_mobile";
import nl_2e_2025_phone_last_opcookies_desktop from "./nl_2e_2025_phone_last_opcookies_desktop";
import nl_2e_2025_phone_last_opcookies_mobile from "./nl_2e_2025_phone_last_opcookies_mobile";
import nl_default_2025_opcookies_desktop from "./nl_default_2025_opcookies_desktop";
import nl_default_2025_opcookies_mobile from "./nl_default_2025_opcookies_mobile";
import fr_default_2025_opcookies_desktop from "./fr_default_2025_opcookies_desktop";
import fr_default_2025_opcookies_mobile from "./fr_default_2025_opcookies_mobile";
import fr_2e_2025_phone_last_opcookies_mobile from "./fr_2e_2025_phone_last_opcookies_mobile";
import fr_2e_2025_phone_last_opcookies_desktop from "./fr_2e_2025_phone_last_opcookies_desktop";
import fr_default_2025_opcookies_v2_desktop from "./fr_default_2025_opcookies_v2_desktop";
import fr_default_2025_opcookies_v2_mobile from "./fr_default_2025_opcookies_v2_mobile";
import nl_default_2025_opcookies_v2_desktop from "./nl_default_2025_opcookies_v2_desktop";
import nl_default_2025_opcookies_v2_mobile from "./nl_default_2025_opcookies_v2_mobile";
import fr_default_2025_opcookies_animations_desktop from "./fr_default_2025_opcookies_animations_desktop";
import fr_default_2025_opcookies_animations_mobile from "./fr_default_2025_opcookies_animations_mobile";

export default {
    fr_coreg_iban_address_desktop,
    fr_coreg_iban_address_mobile,
    nl_coreg_iban_address_desktop,
    nl_coreg_iban_address_mobile,

    fr_new_branding_desktop,
    fr_new_branding_mobile,
    fr_new_branding_phone_optin_desktop,
    fr_new_branding_phone_optin_mobile,

    nl_new_branding_desktop,
    nl_new_branding_mobile,
    nl_new_branding_phone_optin_desktop,
    nl_new_branding_phone_optin_mobile,

    fr_tablet_nb_desktop,
    fr_tablet_nb_mobile,

    nl_tablet_nb_desktop,
    nl_tablet_nb_mobile,

    fr_template_slider_desktop,
    fr_template_slider_mobile,
    nl_template_slider_desktop,
    nl_template_slider_mobile,

    fr_template_carousel_mobile,
    fr_template_carousel_desktop,
    nl_template_carousel_mobile,
    nl_template_carousel_desktop,

    fr_carousel_phone_optin_mobile,
    fr_carousel_phone_optin_desktop,
    nl_carousel_phone_optin_mobile,
    nl_carousel_phone_optin_desktop,

    fr_template_si_2024_mobile,
    fr_template_si_2024_desktop,
    nl_template_si_2024_mobile,
    nl_template_si_2024_desktop,

    fr_optimisation_2024_a_mobile,
    fr_optimisation_2024_a_desktop,
    nl_optimisation_2024_a_mobile,
    nl_optimisation_2024_a_desktop,

    fr_optimisation_2024_b_mobile,
    fr_optimisation_2024_b_desktop,
    nl_optimisation_2024_b_mobile,
    nl_optimisation_2024_b_desktop,

    fr_default_2024_mobile,
    fr_default_2024_desktop,
    fr_default_2025_mobile,
    fr_default_2025_desktop,
    nl_default_2024_mobile,
    nl_default_2024_desktop,
    nl_default_2025_mobile,
    nl_default_2025_desktop,

    fr_carousel_2024_mobile,
    fr_carousel_2024_desktop,
    nl_carousel_2024_mobile,
    nl_carousel_2024_desktop,

    fr_carousel_2025_desktop,
    fr_carousel_2025_mobile,
    nl_carousel_2025_desktop,
    nl_carousel_2025_mobile,

    fr_iban_only_desktop,
    fr_iban_only_mobile,

    fr_carousel_cookbook_desktop,
    fr_carousel_cookbook_mobile,
    nl_carousel_cookbook_desktop,
    nl_carousel_cookbook_mobile,

    fr_cashback_mobile,
    fr_cashback_desktop,

    fr_2euros_2025_desktop,
    fr_2euros_2025_mobile,
    nl_2euros_2025_desktop,
    nl_2euros_2025_mobile,

    fr_2euros_2025_nobox_desktop,
    fr_2euros_2025_nobox_mobile,
    nl_2euros_2025_nobox_desktop,
    nl_2euros_2025_nobox_mobile,

    fr_cashback_fusion_avant_desktop,
    fr_cashback_fusion_avant_mobile,
    fr_cashback_fusion_apres_desktop,
    fr_cashback_fusion_apres_mobile,


    fr_giftchoice_desktop,
    fr_giftchoice_mobile,
    nl_giftchoice_desktop,
    nl_giftchoice_mobile,

    fr_giftchoice_white_desktop,
    fr_giftchoice_white_mobile,
    nl_giftchoice_white_desktop,
    nl_giftchoice_white_mobile,

    fr_2euros_2025_phone_last_desktop,
    fr_2euros_2025_phone_last_mobile,
    fr_2euros_2025_nobox_phone_last_desktop,
    fr_2euros_2025_nobox_phone_last_mobile,
    fr_default_2024_phone_last_desktop,
    fr_default_2024_phone_last_mobile,

    nl_2euros_2025_phone_last_desktop,
    nl_2euros_2025_phone_last_mobile,

    nl_2euros_2025_nobox_phone_last_desktop,
    nl_2euros_2025_nobox_phone_last_mobile,

    nl_2e_2025_phone_last_opcookies_desktop,
    nl_2e_2025_phone_last_opcookies_mobile,
    fr_2e_2025_phone_last_opcookies_mobile,
    fr_2e_2025_phone_last_opcookies_desktop,

    nl_default_2025_opcookies_desktop,
    nl_default_2025_opcookies_mobile,
    fr_default_2025_opcookies_desktop,
    fr_default_2025_opcookies_mobile,

    fr_default_2025_opcookies_v2_desktop,
    fr_default_2025_opcookies_v2_mobile,
    nl_default_2025_opcookies_v2_desktop,
    nl_default_2025_opcookies_v2_mobile,

    fr_default_2025_opcookies_animations_desktop,
    fr_default_2025_opcookies_animations_mobile,

};
